import { LETTERS } from '@components/UI-Components/StandardTableView'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import classNames from 'classnames'

const useStyles = makeStyles(theme => ({
  lettersWrapper: {
    height: '20px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  tabletLettersWrapper: {
    width: '20px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  letter: {
    paddingRight: '12px'
  },
  tabletLetter: {
    padding: '6px 0px',
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  clickable: {
    cursor: 'pointer'
  },
  nonClickable: {
    pointerEvents: 'none'
  },
  letterUnderline: {
    textDecoration: 'underline'
  }
}))

export const MoreFilterLetterJump = ({
  data,
  onHandleLetter,
  letterToHighlight,
  setLetterToHighlight,
  isTablet
}) => {
  return useObserver(function useHook() {
    const classes = useStyles()
    return (
      <div className={isTablet ? classes.tabletLettersWrapper : classes.lettersWrapper}>
        {LETTERS.length &&
          LETTERS.map(letter => {
            const isLetterDataAvailable = data.some(ele => ele?.name === letter)
            return (
              <div
                key={letter}
                id={letter}
                className={classNames({
                  [classes.letter]: !isTablet,
                  [classes.tabletLetter]: isTablet,
                  [classes.clickable]: isLetterDataAvailable,
                  [classes.nonClickable]: !isLetterDataAvailable,
                  [classes.letterUnderline]: letterToHighlight === letter
                })}
                onMouseEnter={() => onHandleLetter(letter)}
                onMouseLeave={() => setLetterToHighlight('')}
              >
                <Typography
                  variant={
                    isLetterDataAvailable
                      ? isTablet
                        ? 'overlineDarkGrey'
                        : 'h6DarkGrey'
                      : isTablet
                      ? 'overlineLightGrey'
                      : 'h6LightGrey'
                  }
                >
                  {letter}
                </Typography>
              </div>
            )
          })}
      </div>
    )
  })
}
